import { ModalService } from './services/ModalService.js';
import { ToastService } from './services/ToastService.js';
import { ClipboardService } from './services/ClipboardService.js';
import { UiToggleService } from './services/UiToggleService.js';
import { ThemeService } from './services/ThemeService.js';
import { ChartService } from './services/ChartService.js';
import { EventBinder } from './services/EventBinder.js';
import { UserActionsService } from './services/UserActionsService.js';
import { DomainActionsService } from './services/DomainActionsService.js';
import { ModalConfirmHelper } from './services/ModalConfirmHelper.js';
import { TokenActionsService } from './services/TokenActionsService.js';
import { SettingsActionsService } from './services/SettingsActionsService.js';
import { AuthService } from './services/AuthService.js';
import { SystemStatusPoller } from './services/SystemStatusPoller.js';

/// Entry-point. Konstruerer service-grafen og hooker EventBinder ind.
/// Razor-views interagerer udelukkende via `data-action`-attributter —
/// ingen inline `onclick`, ingen window-globals.

function bootstrap(): void {
  const toast = new ToastService();
  const modal = new ModalService();
  const clipboard = new ClipboardService(toast);
  const toggles = new UiToggleService(toast);
  const theme = new ThemeService();
  const charts = new ChartService();
  const confirmer = new ModalConfirmHelper(toast, modal);
  const userActions = new UserActionsService(toast, modal, confirmer);
  const domainActions = new DomainActionsService(toast, modal, confirmer);
  const tokenActions = new TokenActionsService(toast, modal);
  const settingsActions = new SettingsActionsService(toast);
  const auth = new AuthService(toast);

  new EventBinder({ modal, toast, clipboard, toggles, theme, userActions, domainActions, confirmer, tokenActions, settingsActions, auth }).bind();
  charts.initAll();

  // Topbar-status-pill: poll'er /api/system/status hvert 30s, pause når
  // fanen er skjult. Service starter sig selv hvis pillen findes på siden
  // (typisk hele app-layoutet; ikke /Account-login).
  new SystemStatusPoller().start();

  // Toast-event fra Razor-views (TempData → script → CustomEvent).
  window.addEventListener('swp-toast', (e: Event) => {
    const detail = (e as CustomEvent<{ msg: string; type?: 'success' | 'error' | 'info' }>).detail;
    toast.show(detail.msg, detail.type ?? 'success');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
